export var NSLMS;
(function (NSLMS) {
    var TLessonContentBlockType;
    (function (TLessonContentBlockType) {
        TLessonContentBlockType["Title"] = "title";
        TLessonContentBlockType["WYSIWYG"] = "wysiwyg";
        TLessonContentBlockType["Video"] = "video";
        TLessonContentBlockType["FullBleedImage"] = "fullBleedImage";
        TLessonContentBlockType["OpenQuestion"] = "openQuestion";
        TLessonContentBlockType["ConditionalContent"] = "conditionalContent";
    })(TLessonContentBlockType = NSLMS.TLessonContentBlockType || (NSLMS.TLessonContentBlockType = {}));
    var TStatus;
    (function (TStatus) {
        TStatus["Draft"] = "draft";
        TStatus["Public"] = "published";
        TStatus["Scheduled"] = "scheduled";
    })(TStatus = NSLMS.TStatus || (NSLMS.TStatus = {}));
})(NSLMS || (NSLMS = {}));
//# sourceMappingURL=lms.js.map